export const bonusTypesEnum = {
  bonus: 0,
  freeSpin: 1,
  jackpot: 2,
  boostedJackpot: 4,
};
